import React, { Component } from "react";
import { MainHeader, MainSidebar } from "../../../components";
import { Container } from "reactstrap";

export default class MainLayout extends Component {
  render() {
    return (
      <div className="app">
        <MainHeader />
        <div className="app-body">
          <MainSidebar {...this.props} />

          <main className="main">
            <div style={{ marginTop: 10 }}></div>
            <Container fluid>{this.props.children}</Container>
          </main>
        </div>
        <footer className="app-footer">
          {/* <span><a href="https://genesisui.com">Clever</a> &copy; 2018 creativeLabs.</span> */}
          <span className="ml-auto">
            Powered by <span style={{ color: "purple" }}>Hair and Hands</span>
          </span>
        </footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/MainLayout/MainLayout.js